import { render } from "./vue-wxlogin.vue?vue&type=template&id=d7ec0e04"
import script from "./vue-wxlogin.vue?vue&type=script&lang=js"
export * from "./vue-wxlogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__